import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, concatMap, map, mergeMap } from 'rxjs/operators';
import { AemDataReadService } from '../../services/aemdataread.service';
import {
  AemDataReadActionsEnums,
  LoadAemDataAction,
  LoadCarouselDetailsAction,
  aemDataActionType,
} from '../actions/aem-data-read-action';

@Injectable()
export class AemDataEffects {
  constructor(
    private _action$: Actions,
    private _aemDataReadService: AemDataReadService,
    private _store: Store
  ) {}
  // GAM-2148: This API is not required for angular app
  /* @Effect()
  getCarouselData$: Observable<any> = this._action$.pipe(
    ofType(AemDataReadActionsEnums.LOAD_AEMDATA),
    mergeMap((action) =>
      this._aemDataReadService.getCarouselData().pipe(
        map((carouselData) => ({
          type: AemDataReadActionsEnums.LOAD_CAROUSEL_DETAILS,
          payload: carouselData,
        }))
      )
    )
  ); */

  getCriticalMessage$: Observable<any> = createEffect(() =>
    this._action$.pipe(
      ofType(AemDataReadActionsEnums.LOAD_AEMDATA),
      mergeMap((action) =>
        this._aemDataReadService.getCriticalMessage().pipe(
          map((criticalMsgData) => ({
            type: AemDataReadActionsEnums.LOAD_CRITICAL_MESSAGE,
            payload: this.transformdata(criticalMsgData),
          }))
        )
      )
    )
  );
  //   @Effect()
  //   getIeCriticalMessage$: Observable<any> = this._action$.pipe(
  //     ofType(AemDataReadActionsEnums.LOAD_AEMDATA),
  //   mergeMap((action) =>
  //   this._aemDataReadService.getIeCriticalMessage().pipe(
  //     map((criticalMsgData) => ({
  //         type: AemDataReadActionsEnums.LOAD_IECRITICAL_MESSAGE,
  //         payload: this.transformdata(criticalMsgData),
  //         })),
  //         )
  // )
  //   );

  transformdata(criticalMessageData) {
    let criticalMsgData = JSON.parse(criticalMessageData);
    if (
      criticalMsgData &&
      criticalMsgData.data &&
      criticalMsgData.data.unifiedLoginAtchubbContentList &&
      Array.isArray(criticalMsgData.data.unifiedLoginAtchubbContentList.items)
    ) {
      return criticalMsgData.data.unifiedLoginAtchubbContentList.items.filter(
        (item) => {
          return (
            item.Description &&
            ((item.Description.plaintext &&
              item.Description.plaintext.trim() !== '') ||
              (item.Description.html && item.Description.html.trim() !== ''))
          );
        }
      );
    }
    return [];
  }
}
